module.exports = [{
      plugin: require('/Users/mnierebinski/Projects/serbianex/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/mnierebinski/Projects/serbianex/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
